// Route configuration for Phase 2 layout shell.
// Central source of truth for: page titles, role-based access, and the
// sidebar navigation order. If you need to add/remove a screen, edit here.

export const ROLES = {
    SUPER_ADMIN: 'super_admin',
    MANAGER: 'manager',
    CC_AGENT: 'cc_agent',
};

// Order here = order of items in the sidebar. Filtering is done by role.
// Dashboard listed FIRST so it appears at the top of the sidebar for every
// role that has access (Phase 12.1 — cc_agent gets "Mon Dashboard" too).
export const NAV_ITEMS = [
    {
        path: '/dashboard',
        title: 'Dashboard',
        icon: 'LayoutGrid',
        allowed: [ROLES.SUPER_ADMIN, ROLES.MANAGER, ROLES.CC_AGENT],
    },
    {
        path: '/commandes',
        title: 'Commandes',
        icon: 'ShoppingBag',
        allowed: [ROLES.SUPER_ADMIN, ROLES.MANAGER, ROLES.CC_AGENT],
    },
    {
        path: '/messagerie',
        title: 'Messagerie',
        icon: 'MessageSquare',
        allowed: [ROLES.SUPER_ADMIN, ROLES.MANAGER, ROLES.CC_AGENT],
    },
    {
        path: '/produits',
        title: 'Produits',
        icon: 'Package',
        allowed: [ROLES.SUPER_ADMIN, ROLES.MANAGER],
    },
    {
        path: '/call-centers',
        title: 'Call Centers',
        icon: 'Headphones',
        allowed: [ROLES.SUPER_ADMIN],
    },
    {
        path: '/utilisateurs',
        title: 'Utilisateurs',
        icon: 'Users',
        allowed: [ROLES.SUPER_ADMIN],
    },
    {
        path: '/parametres',
        title: 'Paramètres',
        icon: 'Settings',
        allowed: [ROLES.SUPER_ADMIN],
    },
];

// Fast lookup by path.
export const ROUTE_META = NAV_ITEMS.reduce((acc, item) => {
    acc[item.path] = item;
    return acc;
}, {});

export function titleForPath(pathname) {
    return ROUTE_META[pathname]?.title || '';
}

export function isRoleAllowed(pathname, role) {
    const meta = ROUTE_META[pathname];
    if (meta) return meta.allowed.includes(role);
    // Fallback: match by top-level base (e.g. "/produits/abc" → "/produits").
    // Lets us role-gate sub-routes without duplicating them in NAV_ITEMS.
    const base = '/' + (pathname.split('/')[1] || '');
    const baseMeta = ROUTE_META[base];
    if (baseMeta) return baseMeta.allowed.includes(role);
    return false;
}

export function landingPathForRole(role) {
    // All authenticated roles land on /dashboard now — Phase 12.1 added
    // "Mon Dashboard" for cc_agent (previously landed on /commandes).
    return '/dashboard';
}

// Nav items the given role is allowed to see, in display order.
export function visibleNavItemsForRole(role) {
    return NAV_ITEMS.filter((item) => item.allowed.includes(role));
}

// Role label + color used in the top-bar badge (matches badge system).
export const ROLE_BADGE = {
    [ROLES.SUPER_ADMIN]: { label: 'Super Admin', color: '#4B3FD8' },
    [ROLES.MANAGER]: { label: 'Manager', color: '#3B82F6' },
    [ROLES.CC_AGENT]: { label: 'Agent CC', color: '#6B7280' },
};

export function initialsFromDisplayName(name) {
    if (!name) return '?';
    const parts = name.trim().split(/\s+/).slice(0, 2);
    return parts.map((p) => p[0]?.toUpperCase() || '').join('') || '?';
}
